var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"starfield"},[_vm._l((40),function(n){return _c('SmallStar',{key:n,class:_vm.randomFill(),style:([_vm.randomScale(), _vm.randomPosition()])})}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }